module.exports = __webpack_public_path__ + "img/six.3aa0a2e3.png";